/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Vam_One_LinerInputs */

const en_exp_vam_one_liner = /** @type {(inputs: Exp_Vam_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meters climbed per hour on your climbs — the number to compare on steep ground, where pace says little.`)
};

const de_exp_vam_one_liner = /** @type {(inputs: Exp_Vam_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Höhenmeter pro Stunde an deinen Anstiegen — die Zahl für steiles Gelände, wo das Tempo wenig sagt.`)
};

/**
* | output |
* | --- |
* | "Meters climbed per hour on your climbs — the number to compare on steep ground, where pace says little." |
*
* @param {Exp_Vam_One_LinerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_vam_one_liner = /** @type {((inputs?: Exp_Vam_One_LinerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Vam_One_LinerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_vam_one_liner(inputs)
	return de_exp_vam_one_liner(inputs)
});